var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ds-myschedule-user" }, [
    _c(
      "div",
      { staticClass: "ds-myschedule-user-search" },
      [
        _c(
          "el-input",
          {
            attrs: { placeholder: "请输入姓名" },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          },
          [
            _c("i", {
              staticClass: "el-input__icon el-icon-search",
              attrs: { slot: "suffix" },
              on: { click: _vm.openSelectUsers },
              slot: "suffix",
            }),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "ds-myschedule-user-list" },
      [
        _c("el-tree", {
          ref: "tree",
          staticClass: "filter-tree",
          attrs: {
            data: _vm.userList,
            props: _vm.defaultProps,
            "filter-node-method": _vm.filterNode,
            "default-checked-keys": _vm.defaultCheckedUserIds,
            "node-key": "id",
            "default-expand-all": "",
            "show-checkbox": "",
          },
          on: { "check-change": _vm.changeUser },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }